import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './index.css'; // Importa tu archivo CSS personalizado
import { useWindowSize } from '@utils/resize';

interface IncidenciasPrincipalProps {
    info: { description: string, image: string, preaviso: number, fechaInicio: string, fechaFin: string }[]
}

export default function IncidenciasPrincipal({ info }: IncidenciasPrincipalProps) {
    const { width } = useWindowSize();
    const currentDate = new Date();
    const [sliderKey, setSliderKey] = useState(0);
    const rootStyles = getComputedStyle(document.documentElement);
    const thirdColor = rootStyles.getPropertyValue('--secondary-color');
    const fourthColor = rootStyles.getPropertyValue('--fourth-color');
    const primaryColor = rootStyles.getPropertyValue('--primary-color');

    let incidenciasActuales = info.filter(incidencia => {
        const fechaFin = new Date(incidencia.fechaFin);
        const fechaInicio = new Date(incidencia.fechaInicio);
        return fechaFin > currentDate && currentDate > fechaInicio;
    });

    let incidenciasProximas: { description: string, image: string, preaviso: number, fechaInicio: string, fechaFin: string }[] = [];
    incidenciasProximas = info.filter(incidencia => {
        const fechaInicio = new Date(incidencia.fechaInicio);
        const fechaInicioPreaviso = new Date(fechaInicio);
        fechaInicioPreaviso.setDate(fechaInicioPreaviso.getDate() - incidencia.preaviso);
        return fechaInicio > currentDate && currentDate > fechaInicioPreaviso;
    }).map(incidencia => ({
        ...incidencia,
        description: incidencia.description ? `Próxima incidencia: ${incidencia.description}` : `Próxima incidencia: Sin datos actualmente`
    }));

    let incidencias = [...incidenciasActuales, ...incidenciasProximas];
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 9700,
        fade: true,
        arrows: false,
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                bgcolor: thirdColor,
                color: '#000000',
                borderRadius: 2,
                textAlign: 'center',
                height: width > 1300 ? '60px' : '70px',
                position: 'relative'
            }}
        >
            {incidencias.length > 0 ? (
                <>
                    <Box sx={{ mr: 2, width: '90%' }}>
                        <Slider {...settings} beforeChange={(next: number) => { setSliderKey(next + 1); }}>
                            {incidencias.map((incidencia, index) => (
                                <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                    <div key={sliderKey} style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={incidencia.image} alt={incidencia.description} style={{ width: '40px', height: '40px', marginLeft: width < 1300 ? '15px' : '' }} />
                                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-start', marginLeft: width > 1300 ? '25px' : '10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            <Typography className={incidencia.description.length > 100 ? 'marquee' : ''} variant={width > 1300 ? "h6" : "body1"} component="div" sx={{ fontWeight: 'bold', mb: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {incidencia.description}
                                            </Typography>
                                        </Box>
                                    </div>
                                </Box>
                            ))}
                        </Slider>
                    </Box>
                </>
            ) : (
                <>
                    <Box sx={{ width: '85%' }}>
                        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 0 }}>
                            No hay incidencias próximamente
                        </Typography>
                    </Box>
                </>
            )}
            <Box>
                <div style={{ backgroundColor: fourthColor, borderRadius: '10px' }}>
                    <Link className='link-subruta' to={'/incidencias'} style={{ width: '10%' }}>
                        <ArrowForwardIosIcon sx={{ width: 35, height: 35, color: primaryColor, marginTop: '3px' }} />
                    </Link>
                </div>
            </Box>
        </Box>
    );
}
